<template>
  <v-container id="error">
    <v-layout column>
      <v-flex class="display-2 text-xs-center my-5">Error</v-flex>
      <v-divider insert></v-divider>
      <v-container lg4>
        <v-flex>
          <p class="subheading mt-3">
            We're sorry. We are having trouble finding that page.
          </p>
        </v-flex>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorPage',
};
</script>

<style scoped></style>
